import api from './api';

export interface TokenSummary {
  username: string;
  tokens_remaining: number;
  tokens_used: number;
  last_updated: string;
  added?: number;
}

export const tokensService = {
  async getMyTokens(): Promise<TokenSummary> {
    const response = await api.get<TokenSummary>('/tokens/me');
    return response.data;
  },

  async purchaseTokens(amount: number): Promise<TokenSummary> {
    const response = await api.post<TokenSummary>('/tokens/purchase', { amount });
    return response.data;
  },
};


